export const dataColors = [
    {
      id: 1,
      color: "yellow"
    },
    {
      id: 2,
      color: "red"
    },
    {
      id: 3,
      color: "blue"
    },
    {
      id: 4,
      color: "brown"
    },
    {
      id: 5,
      color: "green"
    }
];